export default __webpack_public_path__ + "static/media/NRSC_NHP_Irrigation_Report_Rabi_2021-22.86dc523f.pdf";